import { useCallback } from 'react';
import { SubmitType } from '../../../../components/form';
import Deal from '../../../../interfaces/deal';
import { submitFormMap } from './form-parts';
import { route } from '../../../../services/utils';
import { WAREHOUSE_DEAL_VIEW } from '../../../../router/routes';
import { useService } from '../../../../services/services';
import { useHistory, useParams } from 'react-router';
import RecycleDeal from '../../../../interfaces/recycle-deal';
import TabsKeys from '../../../../enums/tab-keys';

export function useDealUpdate() {
  const history = useHistory();
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { dealService } = useService();

  return useCallback<SubmitType<Deal | RecycleDeal>>(
    (form) => [
      dealService.update(farmId, id, submitFormMap(form)),
      (response: Deal | RecycleDeal) => {
        history.push(
          route(WAREHOUSE_DEAL_VIEW, {
            farmId,
            id: response.id,
            tab: TabsKeys.deals,
            dealType: response.type,
          })
        );
      },
    ],
    [farmId, history, dealService, id]
  );
}
